// utils/currency.js
export const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};
// // src/utils/currency.js
// const CURRENCY_FORMATS = {
//   USD: {
//     locale: 'en-US',
//     currency: 'USD',
//   },
//   EUR: {
//     locale: 'de-DE',
//     currency: 'EUR',
//   },
//   GBP: {
//     locale: 'en-GB',
//     currency: 'GBP',
//   },
//   // Add more currencies as needed
// };

// export const formatCurrency = (amount, currency = 'USD') => {
//   const format = CURRENCY_FORMATS[currency] || CURRENCY_FORMATS.USD;

//   return new Intl.NumberFormat(format.locale, {
//     style: 'currency',
//     currency: format.currency,
//   }).format(amount);
// };
